import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { KeyboardEvent, MouseEvent } from 'react';
import ColorElement from '../../colors/ColorElement';

const COLOR_ELEMENT_SIZE = 1.75;
const ACTIVATION_KEYS = ['Enter', ' '];

interface ColorInfoProps {
  name: string;
  code: string;
  showColorIcon: boolean;
  hexCode?: string;
  imageUrl?: string;
  onClick?: () => void;
}

const ColorInfo = ({ imageUrl, hexCode, name, code, showColorIcon, onClick }: ColorInfoProps) => {
  const colorName = name.toLocaleLowerCase();

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!onClick) {
      return;
    }

    event.stopPropagation();
    onClick();
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick || !ACTIVATION_KEYS.includes(event.key)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      role={onClick ? 'button' : undefined}
      tabIndex={-1}
      aria-label={onClick ? name : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      sx={{
        maxWidth: '100%',
        minWidth: 0,
        ...(onClick && { '&:hover': { cursor: 'pointer' } }),
      }}
    >
      {showColorIcon && (
        <ColorElement hexcode={hexCode} imageUrl={imageUrl} size={COLOR_ELEMENT_SIZE} />
      )}

      <Typography noWrap variant="micro2" color="text.secondary" sx={{ flexShrink: 0 }}>
        {code}
      </Typography>

      <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
        <Tooltip fullWidth tabIndex={-1} TooltipContent={colorName}>
          <Typography noWrap variant="body2" color="text.primary">
            {colorName}
          </Typography>
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default ColorInfo;
